import ExportEmailNotice from "./ExportEmailNotice";
import classNames from "classnames";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  DealerExportKind,
  useGetOrganizationsQuery,
} from "~@/graphql/codegen/generated";
import {
  canRequestDealerExport,
  canSeeDealerExport,
} from "~@/hooks/canRequestDealerExport";
import useDealerExport from "~@/hooks/useDealerExport";
import useInternalUser from "~@/hooks/useInternalUser";

// [AI_START::function id="FullExportButton" purpose="Compact full-archive request: one email line plus a button; a 3Beep agent sees the button disabled with a short hint" links=["useDealerExport", "ExportEmailNotice", "DataExportSettings"]]
const FullExportButton: FC<{ className?: string; title?: string | null }> = ({
  className,
  title,
}) => {
  const { t } = useTranslation();
  const { internalUser, isRoot } = useInternalUser();
  const canDownload = canRequestDealerExport(internalUser, isRoot);
  const showDownload = canSeeDealerExport(internalUser, isRoot);
  const { requestExport, loading } = useDealerExport();
  const { data } = useGetOrganizationsQuery();
  const email = data?.getOrganizations?.current?.email;

  if (!showDownload) {
    return null;
  }

  return (
    <div className={classNames("dealer-export", className)}>
      {title ? <p className="dealer-export__title">{title}</p> : null}
      {canDownload ? (
        <ExportEmailNotice email={email} showLinkLifetime />
      ) : (
        <p className="dealer-export__hint">
          {t("export.agent-cannot-download")}
        </p>
      )}
      <button
        className={classNames("button button--h-48 button--stroke-gray-2", {
          "button--is-loading": loading,
          "button--is-disabled": !canDownload,
        })}
        type="button"
        disabled={loading || !canDownload}
        onClick={() => {
          if (canDownload && !loading) {
            void requestExport(DealerExportKind.Communications);
          }
        }}
      >
        <span>{t("export.full-action")}</span>
      </button>
    </div>
  );
};
// [AI_END::FullExportButton]

export default FullExportButton;
